import apiService from './apiService';

// Task List client (#437). A task is a persistent personal checklist item with
// NO time attached. The same data is managed from chat (create_tasks /
// list_tasks / update_tasks / delete_tasks) — every path ends in the BE's
// task_service, so the panel and PAI always agree.
export const taskService = {
    // → { tasks: [{id, content, is_completed, completed_at, source, created_at,
    //    updated_at}], count, total, pending, completed } — CHRONOLOGICAL.
    async list() {
        return apiService.get('/api/tasks');
    },

    async create(content) {
        return apiService.post('/api/tasks', { content, source: 'web' });
    },

    async update(id, patch) {
        return apiService.patch(`/api/tasks/${id}`, patch);
    },

    async remove(id) {
        return apiService.delete(`/api/tasks/${id}`);
    },

    // selector: { taskIds } | { all: true } | { completed: true }
    async bulkDelete({ taskIds, all, completed } = {}) {
        const body = taskIds ? { task_ids: taskIds } : all ? { all: true } : { completed: !!completed };
        return apiService.post('/api/tasks/bulk-delete', body);
    },

    async bulkUpdate({ taskIds, all } = {}, isCompleted) {
        const body = taskIds ? { task_ids: taskIds } : { all: !!all };
        return apiService.post('/api/tasks/bulk-update', { ...body, is_completed: !!isCompleted });
    },
};

export default taskService;
